import { useEffect } from 'react';
import { TsoMinimal } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  randomOrder?: boolean;
};

export function useTsos({ randomOrder = false }: HookOptions = {}) {
  const tsos = useAxios(
    (axios, signal) =>
      axios
        .request<TsoMinimal[]>({
          signal,
          url: `${PRISMA_CONFIG.oldBackendUrl}/tso/?detailLevel=MINIMAL`,
          method: 'GET',
        })
        .then((response) => {
          if (randomOrder) {
            response.data = response.data.sort(() => Math.random() - 0.5);
          }
          return response;
        }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    tsos.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return tsos;
}

export type TsosRequest = ReturnType<typeof useTsos>;
